module.exports = __webpack_public_path__ + "img/rs.8e73f6b2.svg";